module.exports = __webpack_public_path__ + "static/media/graph_mask.049742d0.png";